import { ApiMapType, Methods } from "types/api.d";

const ApiMap: ApiMapType = {
  uploadImageToS3: {
    url: "",
    method: Methods.PUT,
    noAuthHeader: true,
  },
  requestPresignedUrls: {
    url: import.meta.env.VITE_LAMBDA_API_ENDPOINT || '',
    method: Methods.POST,
    noAuthHeader: true,
    noCredentials: true,
  },
  createZip: {
    url: import.meta.env.VITE_LAMBDA_API_ENDPOINT || '',
    method: Methods.POST,
    noAuthHeader: true,
    noCredentials: true,
  },
};

export default ApiMap;
